import React, { forwardRef, useMemo } from 'react';

// GLOBAL VARIABLES
import { SELECT } from 'defaults.js';

// LOCAL FUNCTIONS
import { filterOptions, flattenOptions } from '../functions';

// FUNCTIONS
const customSelectionObject = v => ({ label: v, value: v, isCustom: true });

// MAIN COMPONENT
export const selectedOptions = Component => forwardRef(({
  processSelected,
  ...props
}, ref) => {

  // PROPS
  const {
    value,
    options,
    multiple,
    allowCustom = SELECT.allowCustom,
    onLoadOptions
  } = props;

  // MEMOS
  const validOptions = useMemo(
    () => filterOptions(value, options, multiple),
    [value, options, multiple]
  )
  const customOptions = useMemo(
    () => {
      if (!value) return [];
      if (!allowCustom) return [];
      const valueArray = Array.isArray(value) ? value : String(value).split(',');
      return valueArray.filter(v => flattenOptions(options).find(o => String(o?.value) === String(v)) === undefined).map(customSelectionObject);
    },
    [value, options, allowCustom]
  )
  const selectedOptionsMemo = useMemo(
    () => [...validOptions, ...customOptions],
    [validOptions, customOptions]
  )

  // RENDER
  return <Component
    {...props}
    selectedOptions={!onLoadOptions ? selectedOptionsMemo : undefined}
    ref={ref}
  />
})
